import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MawUserService } from '@medappsware/maw-auth';

@Component({
    selector: 'app-check-portal',
    imports: [RouterModule],
    template: "<div>Checking...</div>",
    encapsulation: ViewEncapsulation.None
})
export class CheckPortalComponent implements OnInit {

  constructor(
    private readonly userService: MawUserService,
    private readonly router: Router,
  ){
    
  }

  ngOnInit(): void {
    let loggedUser = this.userService.user$;
    if(loggedUser?.roles){
      this.setRedirects(loggedUser.roles);
    }
  }

  setRedirects(role: any) {
    if (role && role.length > 0) {
      switch (role[0].name) {
        case 'super_admin': {
          this.router.navigate(['/admin/portal']);
          break;
        }
        case 'assistant_admin': {
          this.router.navigate(['/admin/portal']);
          break;
        }
        case 'tech_admin': {
          this.router.navigate(['/admin/preferences/profile']);
          break;
        }
        case 'patient': {
          this.router.navigate(['/consumer-portal/laboratory/tests-orders']);
          break;
        }
        case 'physician': {
          this.router.navigate(['/provider-portal/my-appointments']);
          break;
        }
        case 'physician_associate': {
          this.router.navigate(['/provider-portal/my-appointments']);
          break;
        }
        case 'nurse_practitioner': {
          this.router.navigate(['/provider-portal/my-appointments']);
          break;
        }
        case 'phlebotomist': {
          this.router.navigate(['/phlebotomist-portal/appointments']);
          break;
        }
        case 'sales_person': {
          this.router.navigate(['/sales-person-portal/coupons']);
          break;
        }
        case 'reference_lab_admin': {
          this.router.navigate(['/reference-labs-admin-portal/lab-details']);
          break;
        }
        case 'fitness_center_admin': {
          this.router.navigate(['/affiliates-admin-portal/coupons']);
          break;
        }
        default: {
          this.router.navigate(['/admin/preferences/profile']);
          break;
        }
      }
    }else{
      this.router.navigate(['/']);
    }
  }
}